import { render, staticRenderFns } from "./data1.vue?vue&type=template&id=6ef16b8c&scoped=true"
import script from "./data1.vue?vue&type=script&lang=js"
export * from "./data1.vue?vue&type=script&lang=js"
import style0 from "./data1.vue?vue&type=style&index=0&id=6ef16b8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef16b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef16b8c')) {
      api.createRecord('6ef16b8c', component.options)
    } else {
      api.reload('6ef16b8c', component.options)
    }
    module.hot.accept("./data1.vue?vue&type=template&id=6ef16b8c&scoped=true", function () {
      api.rerender('6ef16b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/hotelInit/data1.vue"
export default component.exports